export default "__VITE_ASSET__BjHHjOJk__"